import {createSlice} from "@reduxjs/toolkit";
import {loginSuccess} from "features/pages/account/login/reducer";
import {tempPasswordSuccess} from "features/pages/account/temp-password/reducer";
import {LocalStorageService} from "services/utils/local-storage-service";
import {signupSuccess} from "features/pages/account/signup/reducer";
import {onboardingCompleteSuccess} from "features/pages/account/onboarding/reducer";
import errorHandler from "errorReporting";

export const AUTH_STORAGE_KEY = "auth";

export const initialState = {
    loaded: false,
    token: null,
    temp_password: false,
    remember: false,
    onboarding_done: false
};

const saveStateToLocalStorage = (state) => {
    LocalStorageService.setItem(AUTH_STORAGE_KEY, JSON.stringify(state));
}
const removeStateFromLocalStorage = () => {
    LocalStorageService.removeItem(AUTH_STORAGE_KEY);
}

const slice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        resetAuth: (state) => {
            state.token = initialState.token;
            state.temp_password = initialState.temp_password;
            state.remember = initialState.remember;
            state.onboarding_done = initialState.onboarding_done;
            removeStateFromLocalStorage();
            errorHandler.setUser(null);
        },
        initAuth: (state) => {
            const auth_obj = JSON.parse(LocalStorageService.getItem(AUTH_STORAGE_KEY));
            /*istanbul ignore else*/
            if (auth_obj) {
                state.token = auth_obj.token;
                state.temp_password = auth_obj.temp_password;
                state.remember = auth_obj.remember;
                state.onboarding_done = auth_obj.onboarding_done;
                state.loaded = true;
            } else {
                removeStateFromLocalStorage();
            }
            state.loaded = true;
        }
    },
    extraReducers: {
        [loginSuccess]: (state, {payload}) => {
            state.token = payload.token;
            state.temp_password = payload.temp_password;
            state.remember = payload.remember;
            state.onboarding_done = payload.onboarding_done;
            saveStateToLocalStorage(state);
        },
        [tempPasswordSuccess]: (state) => {
            state.temp_password = false;
            saveStateToLocalStorage(state);
        },
        [signupSuccess]: (state, {payload}) => {
            state.token = payload.token;
            state.temp_password = payload.temp_password;
            state.remember = payload.remember;
            state.onboarding_done = payload.onboarding_done;
            saveStateToLocalStorage(state);
        },
        [onboardingCompleteSuccess]: (state) => {
            state.onboarding_done = true;
            saveStateToLocalStorage(state);
        }
    }
});

const {reducer, actions} = slice;
export const {
    resetAuth, initAuth
} = actions;
export default reducer;